import { useQuery } from '@apollo/client';
import { CircularProgress } from '@mui/material';
import type React from 'react';
import { allViewSimple } from 'src/api/viewModels/allViews';
import { cleanPayload } from 'src/helpers/common';
import EditView from './MetaTab/EditView';
import StaticReadView from './MetaTab/StaticReadView';

interface ViewModel {
  componentName: string;
  [key: string]: unknown;
}

interface TabProps {
  isTwoColumn: boolean;
  itemId: string;
  edit: boolean;
  viewModelName: string;
  shared?: boolean;
  compact?: boolean;
}

const Tab: React.FC<TabProps> = ({ isTwoColumn, itemId, edit, viewModelName, shared = false, compact = false }) => {
  const { data, loading, error } = useQuery(allViewSimple, {
    variables: {
      viewName: 'Library',
      componentName: viewModelName,
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-only',
  });

  if (loading) return <CircularProgress color="secondary" />;
  if (error) return <div>Error: {error.message}</div>;

  const cleanedData = cleanPayload(data) as ViewModel[];
  const viewModel = cleanedData[0];

  if (edit) {
    return <EditView isTwoColumn={isTwoColumn} itemId={itemId} viewModel={viewModel.componentName} />;
  } else {
    return (
      <StaticReadView
        isTwoColumn={isTwoColumn}
        id={itemId}
        viewModel={viewModel.componentName}
        shared={shared}
        compact={compact}
      />
    );
  }
};

export default Tab;
